import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSubtract = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.23077 8.76923H8.76923H11.2308H16.7692C17.45 8.76923 18 9.31923 18 10C18 10.6808 17.45 11.2308 16.7692 11.2308H11.2308H8.76923H3.23077C2.55 11.2308 2 10.6808 2 10C2 9.31923 2.55 8.76923 3.23077 8.76923Z",
		fill: "#0D2976"
	})
});
export default SvgSubtract;
